import {
  GET_LITE_EQUIPMENT,
  LITE_EQUIPMENT_ERROR,
  SHOW_LITE_EQUIPMENT_LOADING,
  GET_LITE_EQUIPMENT_DETAILS,
  CREATE_LITE_EQUIPMENT_SUCCESS,
  SHOW_EDIT_LITE_EQUIPMENT_LOADING,
  EDIT_LITE_EQUIPMENT_SUCCESS,
  EDIT_LITE_EQUIPMENT_LOGBOOK_SUCCESS,
  DELETE_LITE_EQUIPMENT,
  EDIT_CURRENT_HOURS_SUCCESS,
} from '../actions/types';

/**
 * maco-magsael-sc-816: Lite Admin - soft delete to permanent delete
 *
 */

const initialState = {
  litegrouplist: [],
  litegroupID: null,
  litegroupdetails: null,
  // Modification start - 07.31.2025 - maco-magsael-sc-816
  litegrouploading: false,
  // Modification end - 07.31.2025 - maco-magsael-sc-816
  liteeditloading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_LITE_EQUIPMENT_LOADING:
      return {
        ...state,
        // Modification start - 07.31.2025 - maco-magsael-sc-816
        litegrouploading: true,
        // Modification end - 07.31.2025 - maco-magsael-sc-816
      };
    case SHOW_EDIT_LITE_EQUIPMENT_LOADING:
      return {
        ...state,
        liteeditloading: true,
      };
    case GET_LITE_EQUIPMENT:
      return {
        ...state,
        litegrouplist: payload,
        litegrouploading: false,
      };
    case EDIT_LITE_EQUIPMENT_SUCCESS:
      return {
        ...state,
        litegrouplist: state.litegrouplist.map((litegroup) =>
          litegroup._id === payload._id
            ? {
                ...litegroup,
                name: payload.name,
                location: payload.location,
                modelNumber: payload.modelNumber,
                serialNumber: payload.serialNumber,
                manufacturer: payload.manufacturer,
                remarks: payload.remarks,
                critical: payload.critical,
                hours: payload.hours,
                isArchived: payload.isArchived,
                department: payload.department,
              }
            : litegroup
        ),
        liteeditloading: false,
      };
    case EDIT_LITE_EQUIPMENT_LOGBOOK_SUCCESS:
      return {
        ...state,
        litegrouplist: state.litegrouplist.map((litegroup) =>
          litegroup._id === payload._id
            ? {
                ...litegroup,
                atSea: payload.atSea,
                atPort: payload.atPort,
              }
            : litegroup
        ),
        liteeditloading: false,
      };
    case EDIT_CURRENT_HOURS_SUCCESS:
      return {
        ...state,
        // Modification start - 07.31.2025 - maco-magsael-sc-816
        litegrouploading: false,
        // Modification end - 07.31.2025 - maco-magsael-sc-816
      };
    case GET_LITE_EQUIPMENT_DETAILS:
      return {
        ...state,
        litegroupdetails: payload,
      };
    case CREATE_LITE_EQUIPMENT_SUCCESS:
      return {
        ...state,
        litegrouplist: [payload, ...state.litegrouplistlitegrouplist],
        // Modification start - 07.31.2025 - maco-magsael-sc-816
        litegrouploading: false,
        // Modification end - 07.31.2025 - maco-magsael-sc-816
      };
    case LITE_EQUIPMENT_ERROR:
      return {
        ...state,
        error: payload,
        // Modification start - 07.31.2025 - maco-magsael-sc-816
        litegrouploading: false,
        // Modification end - 07.31.2025 - maco-magsael-sc-816
      };
    case DELETE_LITE_EQUIPMENT:
      return {
        ...state,
        litegrouplist: state.litegrouplist.filter(
          (litegroup) => litegroup._id !== payload
        ),
        // Modification start - 07.31.2025 - maco-magsael-sc-816
        litegrouploading: false,
        // Modification end - 07.31.2025 - maco-magsael-sc-816
      };
    default:
      return state;
  }
}
